import { BuiltCampaignControllerTrigger } from "./BuiltCampaignControllerTrigger";
export class BuiltCampaignControllerTriggerHasPriorReward extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.filter_names = response.filter_names;
    }
}
